/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M9.12 2h2.832c3.54 0 6.46 2.832 6.46 6.372s-2.92 6.46-6.46 6.46h-1.77a.38.38 0 0 0-.354.354v4.69c0 1.15-.973 2.124-2.124 2.124-1.15 0-2.124-.974-2.124-2.124V5.54A3.55 3.55 0 0 1 9.12 2Zm1.062 8.584h1.77c1.15 0 2.124-.973 2.124-2.124 0-1.15-.973-2.124-2.124-2.124h-1.77a.38.38 0 0 0-.354.354v3.54a.38.38 0 0 0 .354.354Z"
})), "0 0 24 24", "Parking");